// extracted by mini-css-extract-plugin
export default {"modalFooter":"RemoveSubjectModal__modalFooter___gYDzU","bodyContainer":"RemoveSubjectModal__bodyContainer___8HZ9b"};